import { useIsFeatureEnabled } from '@shared/core/featureFlags';
import { useRegistryShopping } from '@apps/registry/admin/RegistryShopping.provider';

export const useIsShopOutOfStockBadgeEnabled = (): boolean => {
  // Intentional: `isShoppingEnabled` reflects admin registry shopping only, so the OOS badge
  // is scoped to that same context and never shows on public /shop routes.
  const { isEnabled: isShoppingEnabled } = useRegistryShopping();
  // only read the flag from Amplitude (which tracks exposure) if we're actually going to use it
  const [isOutOfStockBadgeEnabled] = useIsFeatureEnabled('registryShopOutOfStockBadgeEnabled', { skip: !isShoppingEnabled });
  return isOutOfStockBadgeEnabled;
};
